import browserLocalStorage from "core/services/storageService/localStorage";

const isNotificationsSoundEnabled = browserLocalStorage.get('isNotificationsSoundEnabled');
const soundEnabledInitialValue = isNotificationsSoundEnabled === null ? true : isNotificationsSoundEnabled;

const initialState = {
    notifications: [],
    unreadNotifications: [],
    total: 0,
    unreadTotal: 0,
    isSoundEnabled: soundEnabledInitialValue,
    playSound: false,
};

export default initialState;


